import { Settings01Icon } from '@langchain/untitled-ui-icons';
import { ButtonProps } from '@mui/joy/Button';

import { useState } from 'react';

import { Tooltip } from '@/design-system';
import { IconButton } from '@/design-system/';
import SimpleEditIcon from '@/icons/SimpleEditIcon.svg?react';

import { SessionCrudModalBaseProps, SessionCrudPane } from './SessionCrudPane';

interface SessionCrudPaneProps extends ButtonProps, SessionCrudModalBaseProps {}
export function SessionCrudPaneWithButton({
  session,
  onSuccess,
  ...props
}: SessionCrudPaneProps) {
  const [open, setIsOpen] = useState(false);

  return (
    <>
      <Tooltip title="Edit project">
        <button
          type="button"
          className="flex items-center gap-1 rounded-md border border-secondary p-[5px] text-sm font-semibold hover:bg-secondary"
          onClick={() => setIsOpen(true)}
          {...props}
        >
          <SimpleEditIcon className="h-5 w-5" />
        </button>
      </Tooltip>

      <SessionCrudPane
        session={session}
        onSuccess={onSuccess}
        isOpen={open}
        doClose={() => setIsOpen(false)}
      />
    </>
  );
}

export function SessionCrudPaneWithButtonV2({
  session,
  onSuccess,
}: SessionCrudModalBaseProps) {
  const [open, setIsOpen] = useState(false);

  return (
    <>
      <IconButton
        onClick={() => setIsOpen(true)}
        color="secondary"
        variant="plain"
        icon={Settings01Icon}
        label="Edit project"
        size="md"
      />

      <SessionCrudPane
        session={session}
        onSuccess={onSuccess}
        isOpen={open}
        doClose={() => setIsOpen(false)}
      />
    </>
  );
}
